/* ============================================================================
   ARDAM / K9 RAW - Quiz UI controller (game-like flow)
   No framework. Renders steps into #stage, runs QuizEngine, fires Klaviyo event.
   ============================================================================ */
(function(){
  var stage = document.getElementById('stage');
  var progFill = document.getElementById('progFill');
  var stepCount = document.getElementById('stepCount');
  var backBtn = document.getElementById('backBtn');
  var mascot = document.getElementById('mascot');
  var mascotText = document.getElementById('mascotText');

  // Set true only inside Shopify with a real availability map injected.
  var TREAT_AVAILABILITY = (window.ARDAM_TREAT_AVAILABILITY || {}); // {sku: true/false} legacy
  var TREAT_LIVE = {};  // treat key -> purchasable right now (from live product JSON)
  var TREAT_VID  = {};  // treat key -> live variant id (from live product JSON)

  // Weekly variety: how many weeks (= max flavours) the ladder offers.
  var WEEKLY_MAX_WEEKS = 4;

  /* ---------- LIVE PRICING ----------
     Prices are pulled live from Shopify on load. For each treat we fetch the
     product's public JSON (/products/<handle>.js) and read the variant price
     that matches our variantId (or fall back to the first variant). The baked
     `price` on each treat is used only when a live price is unavailable (e.g.
     Draft products that don't serve public JSON yet). Cart/checkout always uses
     the live Shopify price regardless. */
  var LIVE_PRICE = {}; // treat key -> live price (number)
  function treatPrice(t){
    if(t && typeof LIVE_PRICE[t.key] === 'number') return LIVE_PRICE[t.key];
    return t.price; // baked fallback
  }
  /* treatVariantId: resolve a complement to a live variant id. The consolidated
     bones/offal and single-bag products are option-based, so the map key is
     '<handle>::<Cut>' or '<handle>::<Mix>::<Weight>'. Falls back to the baked
     variantId (CHOMPERZ) and finally the legacy 'treat:<sku>' key. */
  function treatVariantId(t){
    var map = window.ARDAM_VARIANT_MAP || {};
    if(!t) return null;
    if(TREAT_VID[t.key]) return TREAT_VID[t.key];
    if(t.opt && t.opt2 && map[t.handle+'::'+t.opt+'::'+t.opt2]) return map[t.handle+'::'+t.opt+'::'+t.opt2];
    if(t.opt && map[t.handle+'::'+t.opt]) return map[t.handle+'::'+t.opt];
    if(t.variantId) return t.variantId;
    if(t.sku && map['treat:'+t.sku]) return map['treat:'+t.sku];
    return null;
  }
  /* fetchTreatPrices: one fetch per distinct product handle (not per tile), then
     match each complement to its live variant by option title. Populates both
     LIVE_PRICE (key -> $) and TREAT_LIVE (key -> purchasable true/false), so a
     cut that sells out or a draft product renders as unavailable automatically. */
  function fetchTreatPrices(){
    var list = (window.QuizEngine && QuizEngine.ALL_TREATS) ? QuizEngine.ALL_TREATS : [];
    var byHandle = {};
    list.forEach(function(t){ if(t.handle){ (byHandle[t.handle] = byHandle[t.handle] || []).push(t); } });
    var jobs = Object.keys(byHandle).map(function(h){
      return fetch('/products/'+h+'.js', {credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(p){
          if(!p || !p.variants || !p.variants.length){
            byHandle[h].forEach(function(t){ TREAT_LIVE[t.key] = false; });
            return;
          }
          byHandle[h].forEach(function(t){
            var want = t.opt ? (t.opt2 ? (t.opt + ' / ' + t.opt2) : t.opt) : null;
            var v = null, i;
            if(want){
              for(i=0;i<p.variants.length;i++){
                if(String(p.variants[i].title).trim() === want){ v = p.variants[i]; break; }
              }
            }
            if(!v && t.variantId){
              for(i=0;i<p.variants.length;i++){
                if(String(p.variants[i].id) === String(t.variantId)){ v = p.variants[i]; break; }
              }
            }
            if(!v && !want && !t.variantId) v = p.variants[0];
            if(!v){ TREAT_LIVE[t.key] = false; return; }
            TREAT_LIVE[t.key] = (v.available !== false);
            TREAT_VID[t.key] = String(v.id);
            if(typeof v.price !== 'undefined'){ LIVE_PRICE[t.key] = (Number(v.price)||0) / 100; }
          });
        })
        .catch(function(){ /* keep baked fallback, leave availability unknown */ });
    });
    return Promise.all(jobs);
  }

  var A = { species:null, petName:'', breed:'', lifeStage:null, ageMonths:null,
            weightKg:null, _weightTouched:false, activity:null, health:[], allergies:[],
            currentBrand:'', priority:null, format:'weekly', deliveryPref:null, treats:[],
            email:'', marketingConsent:true, catMixOverride:null,
            // --- variety meal planner ---
            planType:'specific',   // 'specific' | 'variety'
            varietyWeeks:1,        // weekly-variety: number of weekly packs = max mixes
            allocation:null,       // [{mixKey, units}] from the editable mixPick screen
            _frozenBlocked:false };// set when a frozen allergy leaves 0 eligible mixes

  var idx = 0;        // index into the active step list
  var history = [];   // visited step ids for back

  function rewardWords(){ return ['Good pick!','Nice!','Love it.','Got it.','Great choice.','Onto it.','Sorted.','Beautiful.']; }
  function flashMascot(msg){
    mascotText.textContent = msg || rewardWords()[Math.floor(Math.random()*8)];
    mascot.classList.add('show');
    clearTimeout(flashMascot._t);
    flashMascot._t = setTimeout(function(){ mascot.classList.remove('show'); }, 1400);
  }

  /* ---------- step definitions (dynamic per species) ---------- */
  function steps(){
    var s = ['intro','species'];
    var tail;
    if(A.species === 'dog'){
      s = s.concat(['petName','breed','lifeStage']);
      if(A.lifeStage === 'puppy') s.push('puppyAge');
      s = s.concat(['weight','activity','health','allergies']);
      // 26 Oct 2026: nothing avoids the selection -> stop at a no-match step (no cart).
      if(QuizEngine.noMatchFor('dog', A.allergies)){ s.push('noMatch'); return s; }
      s = s.concat(['currentBrand','priority','delivery']);
      tail = varietyTail();
      s = s.concat(tail);
    } else if(A.species === 'cat'){
      // Cats have their own Essentials-only range, so the premium/budget
      // priority step is skipped entirely.
      s = s.concat(['petName','breed','weight','activity','health','allergies']);
      if(QuizEngine.noMatchFor('cat', A.allergies)){ s.push('noMatch'); return s; }
      s = s.concat(['currentBrand','delivery']);
      tail = varietyTail();
      s = s.concat(tail);
    }
    return s;
  }

  /* The post-delivery tail differs per route and per Specific/Variety choice.
       bulk:   delivery, bulkWeeks, variety, [if variety] mixPick, treats, result
       weekly: delivery, variety, [if variety] weeklyWeeks, mixPick, treats, result
       frozen: delivery, variety, [if variety & eligible] mixPick / [if blocked] frozenBlock, treats, result
     'variety' is only inserted once we know the route can offer >=2 mixes; small
     dogs whose bulk only reaches 1 block, or cats, can still see it but it will
     present Specific as the only sensible choice (handled inside rVariety). */
  function varietyTail(){
    var t = [];
    if(A.format === 'bulk'){
      t.push('bulkWeeks');
      t.push('variety');
      if(A.planType === 'variety') t.push('mixPick');
    } else if(A.format === 'frozen'){
      t.push('variety');
      // When NO frozen flavour avoids the allergies (every frozen mix has
      // chicken), neither specific nor variety works -> always block, then
      // route to weekly/bulk. Otherwise only variety needs the mixPick step.
      if(frozenFullyBlocked()){
        t.push('frozenBlock');
      } else if(A.planType === 'variety'){
        t.push('mixPick');
      }
    } else { // weekly fresh
      t.push('variety');
      if(A.planType === 'variety'){ t.push('weeklyWeeks'); t.push('mixPick'); }
    }
    t.push('treats'); t.push('result');
    return t;
  }
  function scoringTotal(){ return 7; } // marketing copy: "7 quick questions"

  function go(delta){
    var list = steps();
    if(delta > 0){ history.push(list[idx]); }
    idx = Math.max(0, Math.min(list.length-1, idx + delta));
    render();
  }
  function jumpAfterSpecies(){ idx = 2; render(); } // first real Q after species

  function setProgress(){
    var list = steps();
    var cur = list[idx];
    if(cur === 'intro'){ progFill.style.width='0%'; stepCount.textContent=''; backBtn.classList.remove('show'); return; }
    if(cur === 'species'){ progFill.style.width='6%'; stepCount.textContent=''; backBtn.classList.add('show'); return; }
    // real questions start at idx 2; total real questions = list.length-2 (excl intro+species)
    var totalReal = list.length - 2;       // includes result as the final node
    var realIdx = idx - 1;                  // species=1 doesn't count, first Q = 1
    var pct = Math.round((idx)/(list.length-1)*100);
    progFill.style.width = Math.max(6, pct) + '%';
    if(cur === 'result' || cur === 'noMatch'){ stepCount.textContent='Done'; } // 26 Oct 2026: no-match is an end state
    else { stepCount.textContent = realIdx + '/' + (totalReal-1); }  // questions only, excludes result
    backBtn.classList.add('show');
  }

  /* ---------- helpers ---------- */
  function el(html){ var d=document.createElement('div'); d.innerHTML=html.trim(); return d.firstChild; }
  function mount(node){
    stage.innerHTML='';
    var card = el('<div class="card"></div>');
    card.appendChild(node);
    stage.appendChild(card);
    requestAnimationFrame(function(){ card.classList.add('in'); });
    setProgress();
  }
  function navRow(primaryLabel, onPrimary, primaryDisabled){
    var row = el('<div class="nav"></div>');
    var btn = el('<button class="btn">'+primaryLabel+'</button>');
    if(primaryDisabled) btn.setAttribute('disabled','');
    btn.onclick = onPrimary;
    row.appendChild(btn);
    return {row:row, btn:btn};
  }

  /* ===================== STEP RENDERERS ===================== */
  function render(){
    var cur = steps()[idx];
    ({
      intro:rIntro, species:rSpecies, petName:rPetName, breed:rBreed,
      lifeStage:rLifeStage, puppyAge:rPuppyAge, weight:rWeight, activity:rActivity,
      health:rHealth, allergies:rAllergies, currentBrand:rCurrentBrand,
      priority:rPriority, delivery:rDelivery, bulkWeeks:rBulkWeeks,
      variety:rVariety, weeklyWeeks:rWeeklyWeeks, mixPick:rMixPick, frozenBlock:rFrozenBlock, noMatch:rNoMatch,
      treats:rTreats, result:rResult
    })[cur]();
  }

  function heroMark(){
    var src = window.ARDAM_QUIZ_HERO_IMG;
    if(src){ return '<img class="hero-img" src="'+src+'" alt="Ronan and Nugget" />'; }
    return '<div class="hero-emoji">&#128054;</div>';
  }
  /* C2 (27 Oct 2026): Joe-approved brand-wide sourcing statement and the matched product's real store photo. */
  var SOURCING_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M5 19c8 0 14-6 14-14-8 0-14 6-14 14Z"/><path d="M5 19 13 11"/></svg>';
  function sourcingNote(){ return '<p class="sourcing-note">'+SOURCING_ICON+'<span>We buy most of our meat and produce from Australia’s human food supply chain.</span></p>'; }
  /* Fill `box` with the product's (or the matched variant's) own Shopify image; leaves it empty if there is none. */
  function loadResultPhoto(box, handle, variantId, matchText){
    if(!box || !handle) return;
    fetch('/products/'+handle+'.js').then(function(r){ return r.ok ? r.json() : null; }).then(function(p){
      if(!p) return;
      var v = null;
      if(variantId) v = (p.variants||[]).filter(function(x){ return String(x.id) === String(variantId); })[0];
      if(!v && matchText) v = (p.variants||[]).filter(function(x){ return (x.title||'').indexOf(matchText) !== -1; })[0];
      var src = (v && v.featured_image && v.featured_image.src) || p.featured_image;
      if(!src) return;
      src = (src.indexOf('//') === 0 ? 'https:' : '') + src;
      box.innerHTML = '<img src="'+src+(src.indexOf('?') > -1 ? '&' : '?')+'width=900" alt="'+esc(p.title)+'" loading="lazy">';
      box.classList.add('has-img');
    }).catch(function(){});
  }
  function rIntro(){
    var n = el('<div class="intro">\
      '+heroMark()+'\
      <h1>Let\'s build your pet\'s perfect raw meal plan</h1>\
      <p>Answer a few quick questions and we\'ll match the right K9 Raw plan, mix and portion. Real food. Real health. Made in Sydney.</p>\
      <p class="intro-sourcing">'+SOURCING_ICON+' We buy most of our meat and produce from Australia’s human food supply chain.</p>\
      <div class="badges"><span class="badge">&#9201; About 60 seconds</span><span class="badge">&#127881; Reward at the end</span><span class="badge">&#128666; Fresh or frozen delivery</span></div>\
    </div>');
    savedPetsBlock(n);
    var nav = navRow('Build Your Meal Plan &#8594;', function(){ go(1); });
    n.appendChild(nav.row);
    mount(n);
  }

  /* C2 (28 Oct 2026): signed-in customers see their saved pets (customer.metafields.custom.pets, injected by the
     ardam-quiz section as window.ARDAM_SAVED_PETS). Picking one pre-fills species, name, breed and life stage / age
     band from the date of birth, then goes to the weight question. Every answer can still be changed with Back.
     Weight is never stored with saved pets, so it is always asked. Guests see nothing here. */
  function savedPets(){
    var raw = window.ARDAM_SAVED_PETS; if(typeof raw === 'string'){ try{ raw = JSON.parse(raw); }catch(e){ raw = []; } }
    if(!Array.isArray(raw)) return [];
    return raw.filter(function(p){ return p && p.name && (p.species === 'dog' || p.species === 'cat' || !p.species); }).slice(0, 6);
  }
  function monthsFromDob(dob){
    if(!dob) return null; var d = new Date(dob); if(isNaN(d)) return null;
    var now = new Date(); var m = (now.getFullYear()-d.getFullYear())*12 + (now.getMonth()-d.getMonth());
    if(now.getDate() < d.getDate()) m--; return m >= 0 ? m : null;
  }
  function applySavedPet(p){
    A.species = (p.species === 'cat') ? 'cat' : 'dog'; A.catMixOverride = null;
    if(A.species === 'cat'){ A.priority = 'budget'; }
    A.petName = String(p.name).slice(0, 40); A.breed = p.breed ? String(p.breed).slice(0, 60) : '';
    var m = monthsFromDob(p.dob);
    if(A.species === 'dog'){
      if(m === null){ A.lifeStage = null; }
      else if(m < 12){ A.lifeStage = 'puppy'; A.ageMonths = m < 4 ? 3 : (m < 6 ? 5 : (m < 8 ? 7 : 10)); }
      else { A.lifeStage = (m < 84) ? 'adult' : 'senior'; }
    }
    var list = steps(), target = (A.species === 'dog' && !A.lifeStage) ? 'lifeStage' : 'weight';
    var t = list.indexOf(target); idx = t > 0 ? t : 2;
    flashMascot('Hi ' + A.petName + '!'); render();
  }
  function savedPetsBlock(n){
    var pets = savedPets(); if(!pets.length) return;
    var box = el('<div class="saved-pets"><p class="saved-pets__label">Plan for one of your saved pets</p><div class="saved-pets__list"></div><p class="saved-pets__hint">We\'ll fill in what we know. You can change anything as you go.</p></div>');
    var list = box.querySelector('.saved-pets__list');
    pets.forEach(function(p){
      var em = p.species === 'cat' ? '&#128049;' : '&#128054;';
      var b = el('<button type="button" class="saved-pet"><span aria-hidden="true">'+em+'</span> '+esc(String(p.name))+'</button>');
      b.onclick = function(){ applySavedPet(p); };
      list.appendChild(b);
    });
    n.appendChild(box);
  }

  function rSpecies(){
    var n = el('<div><div class="eyebrow">Step 1</div><h2 class="q-title">Who are we feeding?</h2>\
      <p class="q-sub">Pick your pet and we\'ll tailor everything from here.</p></div>');
    var opts = el('<div class="opts two"></div>');
    [['dog','&#128054;','Dog'],['cat','&#128049;','Cat']].forEach(function(o){
      var b = el('<button class="opt" style="align-items:center;text-align:center"><div class="em">'+o[1]+'</div><div class="ol">'+o[2]+'</div></button>');
      b.onclick = function(){ A.species=o[0]; A.catMixOverride=null; if(o[0]==='cat'){ A.priority='budget'; } flashMascot(); idx=2; render(); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  function rPetName(){
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">What\'s your '+A.species+'\'s name?</h2>\
      <p class="q-sub">We\'ll personalise your plan with it.</p></div>');
    var inp = el('<input class="field" type="text" placeholder="e.g. Rex" autocomplete="off">');
    inp.value = A.petName;
    n.appendChild(inp);
    var nav = navRow('Continue &#8594;', function(){ A.petName = inp.value.trim()||(A.species==='dog'?'your dog':'your cat'); flashMascot(A.petName.length<14?('Hi '+A.petName+'!'):'Lovely name.'); go(1); });
    n.appendChild(nav.row);
    mount(n);
    setTimeout(function(){ inp.focus(); },300);
    inp.addEventListener('keydown', function(e){ if(e.key==='Enter') nav.btn.click(); });
  }

  function rBreed(){
    var pet = A.petName||('your '+A.species);
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">What breed is '+esc(pet)+'?</h2>\
      <p class="q-sub">This pre-fills a healthy starting weight. Not sure or a mix? Just skip it.</p></div>');
    var ac = el('<div class="ac"><input class="field" type="text" placeholder="Start typing a breed..." autocomplete="off"><div class="ac-list"></div></div>');
    var inp = ac.querySelector('.field'); var list = ac.querySelector('.ac-list');
    inp.value = A.breed;
    var breeds = (window.BREEDS && window.BREEDS[A.species]) ? window.BREEDS[A.species] : [];
    var active = -1, matches = [];
    function renderMatches(q){
      q=q.toLowerCase().trim(); active=-1;
      if(!q){ list.classList.remove('show'); return; }
      matches = breeds.filter(function(b){ return b.n.toLowerCase().indexOf(q)!==-1; }).slice(0,8);
      if(!matches.length){ list.classList.remove('show'); ac.classList.remove('open'); return; }
      ac.classList.add('open');
      list.innerHTML = matches.map(function(b,i){
        // Split a trailing "(size/variant)" so the base name reads first and the
        // size shows as a clear pill, e.g. American Bully  [XL].
        var m = b.n.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
        var label = m ? esc(m[1])+'<span class="ac-size">'+esc(m[2])+'</span>' : esc(b.n);
        return '<div class="ac-item" data-i="'+i+'">'+label+'</div>';
      }).join('');
      list.classList.add('show');
      Array.prototype.forEach.call(list.children, function(it){
        it.onclick = function(){ pick(matches[+it.dataset.i]); };
      });
    }
    function pick(b){
      A.breed=b.n; inp.value=b.n; list.classList.remove('show'); ac.classList.remove('open');
      var lk = (window.breedLookup) ? window.breedLookup(A.species,b.n) : null;
      if(lk){ A._breedLo=lk.weightLo; A._breedHi=lk.weightHi; A.weightKg=Math.round(((lk.weightLo+lk.weightHi)/2)*10)/10; A._weightTouched=false; }
      flashMascot('Got it.');
    }
    inp.addEventListener('input', function(){ A.breed=inp.value; renderMatches(inp.value); });
    inp.addEventListener('keydown', function(e){
      if(!list.classList.contains('show')){ if(e.key==='Enter') nav.btn.click(); return; }
      if(e.key==='ArrowDown'){ active=Math.min(matches.length-1,active+1); hl(); e.preventDefault(); }
      else if(e.key==='ArrowUp'){ active=Math.max(0,active-1); hl(); e.preventDefault(); }
      else if(e.key==='Enter'){ if(active>=0){ pick(matches[active]); e.preventDefault(); } else nav.btn.click(); }
    });
    function hl(){ Array.prototype.forEach.call(list.children,function(c,i){ c.classList.toggle('active',i===active); }); }
    document.addEventListener('click',function(e){ if(!ac.contains(e.target)) list.classList.remove('show'); });
    n.appendChild(ac);
    var nav = navRow('Continue &#8594;', function(){ go(1); });
    var skip = el('<button class="btn ghost">Skip</button>');
    skip.onclick = function(){ A.breed=''; A._breedLo=null; A._breedHi=null; go(1); };
    nav.row.appendChild(skip);
    n.appendChild(nav.row);
    mount(n);
    setTimeout(function(){ inp.focus(); },300);
  }

  function rLifeStage(){
    var pet = A.petName||'your dog';
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How old is '+esc(pet)+'?</h2>\
      <p class="q-sub">Life stage shapes the formula and portion.</p></div>');
    var opts = el('<div class="opts"></div>');
    [['puppy','&#128062;','Puppy','Under 12 months'],['adult','&#128054;','Adult','1 to 7 years'],['senior','&#128021;','Senior','7 years and over']].forEach(function(o){
      var b = el('<button class="opt"><div class="em">'+o[1]+'</div><div class="ol">'+o[2]+'</div><div class="od">'+o[3]+'</div></button>');
      b.onclick=function(){ A.lifeStage=o[0]; flashMascot(); idx=idx; go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  function rPuppyAge(){
    var pet = A.petName||'your pup';
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How many months old is '+esc(pet)+'?</h2>\
      <p class="q-sub">Puppies grow fast, so we match the right age band.</p></div>');
    var opts = el('<div class="opts two"></div>');
    [['2-4','2 to 4 months',3],['4-6','4 to 6 months',5],['6-8','6 to 8 months',7],['8-12','8 to 12 months',10]].forEach(function(o){
      var b = el('<button class="opt" style="align-items:center;text-align:center"><div class="ol">'+o[1]+'</div></button>');
      b.onclick=function(){ A.ageMonths=o[2]; flashMascot(); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  function rWeight(){
    var pet = A.petName||('your '+A.species);
    var lo = A._breedLo || 1, hi = A._breedHi || (A.species==='cat'?8:50);
    var minR = A.species==='cat'?1:1, maxR = A.species==='cat'?12:60;
    if(A.weightKg==null) A.weightKg = A.species==='cat'?4:15;
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How much does '+esc(pet)+' weigh?</h2>\
      <p class="q-sub">Slide to '+esc(pet)+'\'s current weight. This sets the meal plan size.</p></div>');
    var box = el('<div class="slider-wrap">\
      <div class="weight-val" id="wv">'+A.weightKg+'<span> kg</span></div>\
      <div class="weight-hint" id="wh"></div>\
      <input type="range" min="'+minR+'" max="'+maxR+'" step="0.5" value="'+A.weightKg+'">\
      <div class="range-ends"><span>'+minR+' kg</span><span>'+maxR+' kg</span></div>\
    </div>');
    var range = box.querySelector('input'); var wv = box.querySelector('#wv'); var wh = box.querySelector('#wh');
    function upd(){ A.weightKg=parseFloat(range.value); wv.innerHTML=A.weightKg+'<span> kg</span>';
      if(A.breed && A._breedLo) wh.textContent='Typical for a '+A.breed+': '+lo+' to '+hi+' kg.'; else wh.textContent=''; }
    range.addEventListener('input',function(){ A._weightTouched=true; upd(); });
    upd();
    n.appendChild(box);
    if(A.breed && A._breedLo){
      n.appendChild(el('<div class="prefill-note"><span>&#10024;</span> Pre-filled from '+esc(A.breed)+'\'s healthy range. Adjust if needed.</div>'));
    }
    var nav = navRow('Continue &#8594;', function(){ flashMascot(); go(1); });
    n.appendChild(nav.row);
    mount(n);
  }

  function rActivity(){
    var pet = A.petName||('your '+A.species);
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How active is '+esc(pet)+'?</h2>\
      <p class="q-sub">This fine-tunes the portion.</p></div>');
    var opts = el('<div class="opts"></div>');
    [['low','&#128164;','Takes it easy','Mostly naps and short walks'],['medium','&#127939;','Nicely active','Daily walks and play'],['high','&#128293;','Constant zoomies','High energy, always on the go']].forEach(function(o){
      var b = el('<button class="opt"><div class="em">'+o[1]+'</div><div class="ol">'+o[2]+'</div><div class="od">'+o[3]+'</div></button>');
      b.onclick=function(){ A.activity=o[0]; flashMascot(); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  // Master list of health-goal chips. Order here is the default fallback order.
  var HEALTH_CHIPS = [['skin','Skin & coat'],['joints','Joints & mobility'],['gut','Sensitive stomach'],['weight','Weight management'],['dental','Dental'],['energy','Energy & vitality']];
  var HEALTH_SLOTS = 6; // always show this many chips

  function rHealth(){
    var pet = A.petName||('your '+A.species);
    // Pull breed-typical focus areas (reference only, never pre-ticked).
    var lk = (A.breed && window.breedLookup) ? window.breedLookup(A.species, A.breed) : null;
    var refRaw = (lk && lk._refHealth) ? lk._refHealth : [];
    // Keep only flags that map to a real chip (drops e.g. 'brachy' which has no chip).
    var chipKeys = HEALTH_CHIPS.map(function(o){ return o[0]; });
    var breedFocus = refRaw.filter(function(k){ return chipKeys.indexOf(k) !== -1; });
    // Build the displayed list: breed-typical chips first, then fill to HEALTH_SLOTS with the rest.
    var ordered = [];
    breedFocus.forEach(function(k){ var o=HEALTH_CHIPS.filter(function(x){return x[0]===k;})[0]; if(o) ordered.push(o); });
    HEALTH_CHIPS.forEach(function(o){ if(breedFocus.indexOf(o[0])===-1) ordered.push(o); });
    var data = ordered.slice(0, HEALTH_SLOTS);

    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">Any health goals for '+esc(pet)+'?</h2>\
      <p class="q-sub">Optional. Pick any that apply, or none. This helps us suggest the right mix. It is not a diagnosis.</p></div>');
    // Soft, non-committal hint when we know the breed (nothing pre-selected).
    if(breedFocus.length){
      var labels = breedFocus.map(function(k){ var o=HEALTH_CHIPS.filter(function(x){return x[0]===k;})[0]; return o?o[1].toLowerCase():k; });
      var hintTxt = labels.length===1 ? labels[0] : labels.slice(0,-1).join(', ')+' and '+labels[labels.length-1];
      n.appendChild(el('<div class="prefill-note"><span>&#10024;</span> Common focus areas for '+esc(A.breed)+': '+hintTxt+'. Pick what fits, or none.</div>'));
    }
    var chips = el('<div class="chips"></div>');
    data.forEach(function(o){
      var c = el('<button class="chip">'+o[1]+'</button>');
      if(A.health.indexOf(o[0])!==-1) c.classList.add('sel');
      c.onclick=function(){ toggle(A.health,o[0]); c.classList.toggle('sel'); none.classList.remove('sel'); };
      chips.appendChild(c);
    });
    var none = el('<button class="chip none">No specific concerns</button>');
    none.onclick=function(){ A.health=[]; Array.prototype.forEach.call(chips.querySelectorAll('.chip'),function(c){ if(c!==none)c.classList.remove('sel'); }); none.classList.toggle('sel'); };
    chips.appendChild(none);
    n.appendChild(chips);
    var nav = navRow('Continue &#8594;', function(){ flashMascot(); go(1); });
    n.appendChild(nav.row);
    mount(n);
  }

  function rAllergies(){
    var pet = A.petName||('your '+A.species);
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">Any food allergies or proteins to avoid?</h2>\
      <p class="q-sub">Optional. We\'ll filter out mixes whose listed ingredients include these. This is not an allergy guarantee. Check the full ingredient list and talk to your vet about allergies.</p></div>');
    var chips = el('<div class="chips"></div>');
    var data = [['chicken','Chicken'],['beef','Beef'],['lamb','Lamb'],['kangaroo','Kangaroo'],['duck','Duck'],['fish','Fish'],['grain','Grain'],['dairy','Dairy']];
    data.forEach(function(o){
      var c = el('<button class="chip">'+o[1]+'</button>');
      if(A.allergies.indexOf(o[0])!==-1) c.classList.add('sel');
      c.onclick=function(){ toggle(A.allergies,o[0]); c.classList.toggle('sel'); none.classList.remove('sel'); };
      chips.appendChild(c);
    });
    var none = el('<button class="chip none">No known allergies</button>');
    none.onclick=function(){ A.allergies=A.allergies.filter(function(x){ return x==='__other'; }); Array.prototype.forEach.call(chips.querySelectorAll('.chip'),function(c){ if(c!==none)c.classList.remove('sel'); }); none.classList.toggle('sel'); };
    chips.appendChild(none);
    n.appendChild(chips);
    var other = el('<input class="field" type="text" placeholder="Other (type it here)" style="margin-top:14px">');
    other.value = A._otherAllergy||'';
    other.addEventListener('input',function(){ A._otherAllergy=other.value.trim(); });
    n.appendChild(other);
    var nav = navRow('Continue &#8594;', function(){ flashMascot(); go(1); });
    n.appendChild(nav.row);
    mount(n);
  }

  function rCurrentBrand(){
    var pet = A.petName||('your '+A.species);
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">What does '+esc(pet)+' eat right now?</h2>\
      <p class="q-sub">Tell us the brand or food type. It helps us plan a smooth switch to raw.</p></div>');
    var inp = el('<input class="field" type="text" placeholder="e.g. dry kibble, another raw brand, home-cooked" autocomplete="off">');
    inp.value=A.currentBrand;
    n.appendChild(inp);
    n.appendChild(el('<div class="help">We\'ll include free transition tips with your results.</div>'));
    var nav = navRow('Continue &#8594;', function(){ A.currentBrand=inp.value.trim(); flashMascot(); go(1); });
    var skip = el('<button class="btn ghost">Skip</button>'); skip.onclick=function(){ A.currentBrand=''; go(1); };
    nav.row.appendChild(skip);
    n.appendChild(nav.row);
    mount(n);
    setTimeout(function(){ inp.focus(); },300);
    inp.addEventListener('keydown',function(e){ if(e.key==='Enter') nav.btn.click(); });
  }

  function rPriority(){
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">What matters most to you?</h2>\
      <p class="q-sub">Both ranges are complete and balanced raw food. This just sets your default mix.</p></div>');
    var opts = el('<div class="opts"></div>');
    [['budget','&#128176;','Great value','Our Essentials range. Balanced raw, friendly price.'],['premium','&#11088;','Premium complete','Our Complete range. Functional support built in.']].forEach(function(o){
      var b = el('<button class="opt"><div class="em">'+o[1]+'</div><div class="ol">'+o[2]+'</div><div class="od">'+o[3]+'</div></button>');
      b.onclick=function(){ A.priority=o[0]; flashMascot(); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  /* Single route selector. Delivery choice drives packing: it sets BOTH
     deliveryPref and format together so they can never conflict.
       Fresh weekly -> weekly portioned packs
       Bulk         -> bulk bag (fresh only; you portion at home)
       Frozen       -> frozen food, next-day metro (no bulk) */
  function rDelivery(){
    var isCat = (A.species === 'cat');
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How would you like it delivered?</h2>\
      <p class="q-sub">Each route has its own range. Pick the one that suits you.</p></div>');
    var opts = el('<div class="opts"></div>');
    // [deliveryPref, format, emoji, label, desc]
    var routes = [
      ['weekly_fresh','weekly','&#128197;','Fresh, weekly','Pre-portioned weekly packs, delivered ready to feed'],
      ['bulk','bulk','&#127981;','Bulk','Best value. One big bag you portion at home'],
      ['frozen','frozen','&#10052;','Frozen, next-day','Frozen food delivered next-day to metro areas']
    ];
    // Frozen is dog-only in the catalog; hide it for cats.
    if(isCat) routes = routes.filter(function(r){ return r[0] !== 'frozen'; });
    routes.forEach(function(o){
      var b = el('<button class="opt"><div class="em">'+o[2]+'</div><div class="ol">'+o[3]+'</div><div class="od">'+o[4]+'</div></button>');
      b.onclick=function(){ A.deliveryPref=o[0]; A.format=o[1]; flashMascot('Almost there!'); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    mount(n);
  }

  /* Bulk-only step: show the feeding calc, ask how many weeks of food, size the bag. */
  function rBulkWeeks(){
    var pet = A.petName||('your '+A.species);
    var f = QuizEngine.computeFeeding(A);
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How much bulk for '+esc(pet)+'?</h2>\
      <p class="q-sub">Based on weight and activity, '+esc(pet)+' eats about <strong>'+f.gLow+' to '+f.gHigh+'g a day</strong> ('+f.meals+'), roughly <strong>'+f.weeklyKg.toFixed(1)+'kg a week</strong>. How many weeks would you like?</p></div>');
    var opts = el('<div class="opts opts-grid"></div>');
    [1,2,3,4].forEach(function(w){
      var plan = QuizEngine.bulkPlan(f.weeklyKg, w);
      var b = el('<button class="opt"><div class="ol">'+w+' week'+(w>1?'s':'')+'</div>\
        <div class="od">About '+plan.totalNeededKg.toFixed(1)+'kg &#8594; '+plan.bagKg+'kg bag</div></button>');
      if(A.bulkWeeks===w) b.classList.add('sel');
      b.onclick=function(){ A.bulkWeeks=w; flashMascot('Good pick!'); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    n.appendChild(el('<div class="help">Bulk bags come as a 10kg bag, then in 5kg steps. We round up to the nearest size so you never run short.</div>'));
    mount(n);
  }

  /* ===================== VARIETY STEPS ===================== */

  // Compute current capacity + pool for the active route. Used by the variety
  // toggle, weeks step and mixPick. Recomputed each render so allergy/weeks
  // changes are always reflected.
  function varietyCtx(){
    var feeding = QuizEngine.computeFeeding(A);
    var cap = QuizEngine.varietyCapacity(A.format, feeding, {bulkWeeks:A.bulkWeeks, weeks:A.varietyWeeks});
    var pool = QuizEngine.varietyPool(A.format, {species:A.species, allergies:A.allergies, priority:A.priority, health:A.health, lifeStage:A.lifeStage});
    return {feeding:feeding, cap:cap, pool:pool};
  }

  // True when the dog chose frozen but NO frozen flavour avoids their allergies
  // (every frozen mix contains chicken). In that case neither a specific nor a
  // variety frozen plan is possible, so we route to the frozenBlock step.
  function frozenFullyBlocked(){
    if(A.species !== 'dog' || A.format !== 'frozen') return false;
    var elig = QuizEngine.frozenEligibleMixes(A.allergies || []);
    return elig.length === 0;
  }

  /* Specific vs Variety toggle. Inserted after bulkWeeks (bulk) or delivery
     (weekly/frozen). Explains what each plan means for THIS route. If the route
     can only support one mix (e.g. tiny dog on bulk = 1 block, or frozen allergy
     wipes the pool), variety is still offered but routes sensibly. */
  function rVariety(){
    var pet = A.petName||('your '+A.species);
    var ctx = varietyCtx();
    var unit = ctx.cap.unit;        // block | pack | box
    var maxMixes = ctx.cap.maxMixes;
    var poolSize = ctx.pool.length;
    // Frozen: detect the 0-eligible block case up front.
    A._frozenBlocked = (A.format === 'frozen' && poolSize === 0);
    // For weekly the number of weeks (= max flavours) is chosen AFTER this toggle
    // on the weeklyWeeks step, so cap.maxMixes is still the default 1 here. The
    // weeks ladder allows up to 4, so variety can unlock whenever the pool has
    // 2+ eligible mixes. Use that ceiling instead of the not-yet-chosen weeks.
    if(A.format === 'weekly'){ maxMixes = WEEKLY_MAX_WEEKS; }
    // How many distinct mixes can variety actually realise on this route?
    var realMax = Math.min(maxMixes, poolSize);

    var unitWord = unit==='block' ? '10kg blocks' : unit==='box' ? 'frozen boxes' : 'weekly packs';
    var varietyDesc;
    if(A.format === 'bulk'){
      varietyDesc = 'Mix it up. Every 10kg of food unlocks another flavour. We round up to whole bags, and you decide how much of each.';
    } else if(A.format === 'frozen'){
      varietyDesc = 'A blend of our frozen mixes. We work out how many 5kg boxes '+esc(pet)+' needs and you split them across flavours.';
    } else {
      varietyDesc = 'A blend of flavours. Each week of food adds another flavour, and you can double up on a favourite.';
    }

    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">One flavour, or a variety?</h2>\
      <p class="q-sub">Both are complete and balanced. Pick how you\'d like to feed '+esc(pet)+'.</p></div>');
    var opts = el('<div class="opts"></div>');

    var bSpec = el('<button class="opt"><div class="em">&#127869;</div><div class="ol">Specific plan</div>\
      <div class="od">One mix we match to '+esc(pet)+'. Simple and consistent.</div></button>');
    if(A.planType==='specific') bSpec.classList.add('sel');
    bSpec.onclick=function(){ A.planType='specific'; A.allocation=null; flashMascot('Good pick!'); rebuildFromVariety(); };
    opts.appendChild(bSpec);

    var canVary = (realMax >= 2);
    var bVar = el('<button class="opt'+(canVary?'':' gated')+'"><div class="em">&#129385;</div><div class="ol">Variety plan</div>\
      <div class="od">'+varietyDesc+'</div>'+(canVary?'':'<div class="soon">Needs more food to unlock</div>')+'</button>');
    if(canVary){
      if(A.planType==='variety') bVar.classList.add('sel');
      bVar.onclick=function(){ A.planType='variety'; A.allocation=null; flashMascot('Variety it is!'); rebuildFromVariety(); };
    } else {
      bVar.disabled = true;
    }
    opts.appendChild(bVar);
    n.appendChild(opts);

    if(A.planType==='variety' && !canVary){
      // shouldn't happen (disabled), but guard
      A.planType='specific';
    }
    var catBulkSingle = (A.species==='cat' && A.format==='bulk');
    if(!canVary){
      var why = frozenFullyBlocked()
        ? 'Heads up: every complete recipe in our frozen range lists at least one of '+esc((A.allergies&&A.allergies.length)?A.allergies.join(', '):'those ingredients')+', so a frozen plan isn\'t a fit for '+esc(pet)+'. We\'ll point you to Weekly or Bulk, which have the full flavour range.'
        : catBulkSingle
          ? 'One bulk bag holds a single flavour, and '+esc(pet)+' needs just one 10kg bag. You can pick any flavour you like on the next screen. Prefer to mix flavours? Switch to Weekly, where each pack can be a different one.'
          : A.format==='bulk'
            ? 'A variety plan needs at least 20kg of food (two 10kg blocks). '+esc(pet)+'\'s plan is smaller, so a single mix is the best fit.'
            : A.format==='frozen'
              ? 'We don\'t have enough frozen flavours that suit '+esc(pet)+' for a variety box. A single mix works best here.'
              : 'A variety plan unlocks with two or more weeks of food. For one week we\'ll match a single mix.';
      n.appendChild(el('<div class="help">'+why+'</div>'));
      if(catBulkSingle){
        var switchRow = el('<div class="opts" style="margin-top:12px"></div>');
        var bSwitch = el('<button class="opt"><div class="em">&#128197;</div><div class="ol">Switch to Fresh, weekly</div>\
          <div class="od">Pre-portioned packs, and you can mix flavours week to week</div></button>');
        bSwitch.onclick=function(){ A.deliveryPref='weekly_fresh'; A.format='weekly'; A.planType='specific'; A.allocation=null; flashMascot('Switched to weekly.'); rebuildFromVariety(); };
        switchRow.appendChild(bSwitch);
        n.appendChild(switchRow);
      }
    }

    var nav = navRow('Continue &#8594;', function(){ go(1); });
    n.appendChild(nav.row);
    mount(n);
  }

  // After a Specific/Variety toggle the step list changes shape. Re-render in
  // place on the same 'variety' step so back/forward stays sane.
  function rebuildFromVariety(){
    var list = steps();
    var vi = list.indexOf('variety');
    if(vi !== -1) idx = vi;
    render();
  }

  /* Weekly-variety only: how many weeks of food (= how many flavours unlock).
     1 week = 1 flavour, 2 weeks = 2, etc. Capped at WEEKLY_MAX_WEEKS and by the
     number of eligible flavours in the pool (can't unlock more flavours than
     exist after allergy filtering). */
  function rWeeklyWeeks(){
    var pet = A.petName||('your '+A.species);
    var f = QuizEngine.computeFeeding(A);
    var pool = QuizEngine.varietyPool(A.format, {species:A.species, allergies:A.allergies, priority:A.priority, health:A.health, lifeStage:A.lifeStage});
    var maxWeeks = Math.max(1, Math.min(WEEKLY_MAX_WEEKS, pool.length));
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">How many weeks for '+esc(pet)+'?</h2>\
      <p class="q-sub">'+esc(pet)+' eats about <strong>'+f.weeklyKg.toFixed(1)+'kg a week</strong>. Each week unlocks another flavour you can choose.</p></div>');
    var opts = el('<div class="opts opts-grid"></div>');
    var weeks = [];
    for(var w=1; w<=maxWeeks; w++){ weeks.push(w); }
    weeks.forEach(function(w){
      var b = el('<button class="opt"><div class="ol">'+w+' week'+(w>1?'s':'')+'</div>\
        <div class="od">Up to '+w+' flavour'+(w>1?'s':'')+'</div></button>');
      if(A.varietyWeeks===w) b.classList.add('sel');
      b.onclick=function(){ A.varietyWeeks=w; A.allocation=null; flashMascot('Good pick!'); go(1); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    n.appendChild(el('<div class="help">You\'ll pick the flavours next. Want more of one? You can double up there.</div>'));
    mount(n);
  }

  /* Frozen block: no frozen flavour avoids the allergies (every frozen mix has
     chicken), so neither a specific nor a variety frozen plan is possible. Send
     them to Weekly or Bulk, which carry the full flavour range. */
  function rFrozenBlock(){
    var pet = A.petName||('your '+A.species);
    var allergyTxt = (A.allergies&&A.allergies.length) ? A.allergies.join(', ') : 'those proteins';
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">No complete frozen recipe avoids '+esc(allergyTxt)+'</h2>\
      <p class="q-sub">Every complete recipe in our frozen range lists at least one of '+esc(allergyTxt)+', so a frozen plan isn\'t a fit for '+esc(pet)+'. Our frozen Turkey is a complementary food, not a complete diet, so we don\'t build a meal plan around it. Our Weekly and Bulk ranges have the full set of flavours, and may have options whose listed ingredients avoid '+esc(allergyTxt)+'. This is not an allergy guarantee. Check the full ingredient list and talk to your vet about allergies.</p></div>');
    var opts = el('<div class="opts"></div>');
    [['weekly_fresh','weekly','&#128197;','Switch to Fresh, weekly','Full flavour range, pre-portioned'],
     ['bulk','bulk','&#127981;','Switch to Bulk','Full flavour range, best value']].forEach(function(o){
      var b = el('<button class="opt"><div class="em">'+o[2]+'</div><div class="ol">'+o[3]+'</div><div class="od">'+o[4]+'</div></button>');
      b.onclick=function(){ A.deliveryPref=o[0]; A.format=o[1]; A._frozenBlocked=false; A.allocation=null; flashMascot('Sorted.'); rebuildFromVariety(); };
      opts.appendChild(b);
    });
    n.appendChild(opts);
    n.appendChild(el('<div class="help">You can always change delivery later. Both ranges are complete and balanced raw food.</div>'));
    mount(n);
  }

  /* 26 Oct 2026: no recipe avoids every selected ingredient (e.g. beef + duck).
     Nothing is recommended and nothing can be added to the cart from here. */
  function rNoMatch(){
    var pet = A.petName||('your '+A.species);
    var sel = (A.allergies||[]).join(', ');
    var n = el('<div><div class="eyebrow">No match</div><h2 class="q-title">We don\'t have a recipe that avoids '+esc(sel)+'</h2>\
      <p class="q-sub">Based on their listed ingredients, every '+(A.species==='cat'?'cat':'dog')+' recipe we make includes at least one of '+esc(sel)+', so we can\'t recommend a plan for '+esc(pet)+'. This is not an allergy guarantee. Check the full ingredient list and talk to your vet about allergies.</p></div>');
    var opts = el('<div class="opts"></div>');
    var bEdit = el('<button class="opt" data-nomatch-edit><div class="em">&#9998;</div><div class="ol">Change what to avoid</div><div class="od">Go back and adjust the list</div></button>');
    bEdit.onclick=function(){ var i=steps().indexOf('allergies'); if(i!==-1){ idx=i; render(); } };
    opts.appendChild(bEdit);
    opts.appendChild(el('<a class="opt" data-nomatch-contact href="/pages/contact-us" style="display:block;text-decoration:none;color:inherit"><div class="em">&#128172;</div><div class="ol">Ask our team</div><div class="od">Tell us what '+esc(pet)+' needs to avoid</div></a>'));
    n.appendChild(opts);
    mount(n);
  }

  /* ----- Editable allocation screen (mixPick) -----
     The heart of the variety experience. We seed a recommended blend, show a
     running tally of units used vs available, and let the owner add / remove /
     rebalance within the allergy-eligible pool. Primary button is disabled
     until every unit is assigned. */
  function rMixPick(){
    var pet = A.petName||('your '+A.species);
    var ctx = varietyCtx();
    var cap = ctx.cap, pool = ctx.pool;
    var unit = cap.unit;                       // block | pack | box
    var unitNoun = unit==='block' ? '10kg block' : unit==='box' ? '5kg box' : 'weekly pack';
    var unitNounP = unit==='block' ? '10kg blocks' : unit==='box' ? '5kg boxes' : 'weekly packs';
    var total = cap.totalUnits;

    // Seed allocation if we don't have a valid one yet (or pool/units changed).
    if(!A.allocation || !allocValid(A.allocation, pool, total)){
      A.allocation = QuizEngine.defaultAllocation(pool, total);
    }

    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">Build '+esc(pet)+'\'s variety plan</h2>\
      <p class="q-sub">We\'ve started you with a blend. Adjust the amounts, swap a flavour, or add another. '+(unit==='box'?'Each box is 5kg (10 x 500g portions).':'')+'</p></div>');

    var tally = el('<div class="alloc-tally"><span class="alloc-used"></span> of <strong>'+total+'</strong> '+(total===1?unitNoun:unitNounP)+' assigned</div>');
    n.appendChild(tally);

    var listWrap = el('<div class="alloc-list"></div>');
    n.appendChild(listWrap);

    var addWrap = el('<div class="alloc-add"></div>');
    n.appendChild(addWrap);

    var navObj = navRow('See my plan &#8594;', function(){ flashMascot('Building your plan...'); go(1); });
    n.appendChild(navObj.row);
    mount(n);

    function used(){ return QuizEngine.allocationUnits(A.allocation); }
    function poolMix(key){ return pool.filter(function(m){return m.key===key;})[0] || {key:key,name:key}; }
    function inAlloc(key){ return A.allocation.some(function(a){return a.mixKey===key;}); }
    function availMixes(){ return pool.filter(function(m){ return !inAlloc(m.key); }); }

    function draw(){
      // rows
      listWrap.innerHTML='';
      A.allocation.forEach(function(a){
        var m = poolMix(a.mixKey);
        var kgNote = unit==='block' ? ' &middot; '+(a.units*10)+'kg' : unit==='box' ? ' &middot; '+(a.units*5)+'kg' : '';
        var row = el('<div class="alloc-row">\
          <div class="alloc-name">'+esc(m.name)+'<span class="alloc-sub">'+(a.units)+' &times; '+unitNoun+kgNote+'</span></div>\
          <div class="alloc-step">\
            <button class="stp minus" aria-label="Remove one">&minus;</button>\
            <span class="stp-n">'+a.units+'</span>\
            <button class="stp plus" aria-label="Add one">+</button>\
            <button class="stp rm" aria-label="Remove flavour">&times;</button>\
          </div></div>');
        var u = used();
        row.querySelector('.plus').onclick=function(){ if(used()<total){ a.units++; draw(); } };
        row.querySelector('.minus').onclick=function(){ if(a.units>1){ a.units--; draw(); } else { removeLine(a.mixKey); } };
        row.querySelector('.rm').onclick=function(){ removeLine(a.mixKey); };
        // disable plus when full
        if(used()>=total) row.querySelector('.plus').setAttribute('disabled','');
        // can't remove the last remaining line entirely
        if(A.allocation.length<=1) row.querySelector('.rm').setAttribute('disabled','');
        listWrap.appendChild(row);
      });

      // add-a-flavour control
      addWrap.innerHTML='';
      var avail = availMixes();
      if(avail.length && A.allocation.length < Math.min(cap.maxMixes, pool.length) && used()<total){
        var sel = el('<div class="alloc-addrow"><span>Add a flavour:</span></div>');
        var chipBox = el('<div class="chips" style="margin-top:8px"></div>');
        avail.forEach(function(m){
          var c = el('<button class="chip">'+esc(m.name)+'</button>');
          c.onclick=function(){ A.allocation.push({mixKey:m.key, units:1}); flashMascot('Added.'); draw(); };
          chipBox.appendChild(c);
        });
        sel.appendChild(chipBox);
        addWrap.appendChild(sel);
      } else if(used()<total){
        addWrap.appendChild(el('<div class="help">Add more of a flavour above to use your remaining '+(total-used())+' '+((total-used())===1?unitNoun:unitNounP)+'.</div>'));
      }

      // tally + button state
      var u = used();
      tally.querySelector('.alloc-used').innerHTML = '<strong'+(u===total?' class="ok"':' class="warn"')+'>'+u+'</strong>';
      tally.classList.toggle('full', u===total);
      if(u===total){ navObj.btn.removeAttribute('disabled'); }
      else { navObj.btn.setAttribute('disabled',''); }
    }
    function removeLine(key){
      if(A.allocation.length<=1) return;
      A.allocation = A.allocation.filter(function(a){return a.mixKey!==key;});
      flashMascot('Removed.'); draw();
    }
    draw();
  }

  // An allocation is valid if every mix is still in the pool and total<=capacity.
  function allocValid(alloc, pool, total){
    if(!alloc || !alloc.length) return false;
    var keys = pool.map(function(m){return m.key;});
    for(var i=0;i<alloc.length;i++){ if(keys.indexOf(alloc[i].mixKey)===-1) return false; }
    return QuizEngine.allocationUnits(alloc) <= total && alloc.length <= Math.min(total, pool.length);
  }

  /* treatAvailable: live product JSON is the source of truth. Before it lands we
     show non-gated tiles (baked catalogue) and hide gated ones (draft CHOMPERZ). */
  function treatAvailable(t){
    if(typeof TREAT_LIVE[t.key] === 'boolean') return TREAT_LIVE[t.key];
    if(t.gated) return TREAT_AVAILABILITY[t.sku] === true;
    return !!treatVariantId(t);
  }

  var TREAT_GROUP_LABEL = {
    chomperz:"Air-dried treats",
    necks:"Necks &amp; frames",
    bones:"Bones &amp; chews",
    offal:"Offal &amp; organs",
    fish:"Fish",
    bag:"Top-up bags"
  };
  var TREAT_GROUP_ORDER = ["chomperz","necks","bones","offal","fish","bag"];

  function rTreats(){
    var pet = A.petName||('your '+A.species);
    var isFrozen = (A.format === 'frozen');
    var mixKey = null;
    try{
      if(A.planType === 'variety'){
        var al = A.allocation || QuizEngine.buildVarietyRecommendation(A).allocation;
        mixKey = al && al[0] && al[0].mixKey;
      } else {
        var rc = QuizEngine.buildRecommendation(A);
        mixKey = rc && rc.mix && rc.mix.key;
      }
    }catch(e){}
    var n = el('<div><div class="eyebrow">'+stepLabel()+'</div><h2 class="q-title">Anything to add for '+esc(pet)+'?</h2>\
      <p class="q-sub">Single-ingredient treats, raw bones and offal that complement '+esc(pet)+'\u2019s meals. Optional, tap to add.</p></div>');

    // 26 Oct 2026: extras are filtered by the same exclusions; earlier picks that are now
    // excluded (after a back-navigation) are dropped.
    var allTreats = QuizEngine.complementsFor(A.species, isFrozen, mixKey);
    var treatList = QuizEngine.complementsFor(A.species, isFrozen, mixKey, A.allergies);
    A.treats = A.treats.filter(function(k){ var t = QuizEngine.treatByKey(k); return !t || QuizEngine.treatAllowed(t, A.allergies); });
    var hiddenCount = allTreats.length - treatList.length;
    var groups = {};
    treatList.forEach(function(t){ (groups[t.group] = groups[t.group] || []).push(t); });

    TREAT_GROUP_ORDER.forEach(function(g){
      var items = groups[g];
      if(!items || !items.length) return;
      n.appendChild(el('<div class="section-h">'+TREAT_GROUP_LABEL[g]+'</div>'));
      var grid = el('<div class="treat-grid"></div>');
      items.forEach(function(t){
        var avail = treatAvailable(t);
        var card = el('<button class="treat'+(avail?'':' gated')+'">\
          <div class="tn">'+esc(t.name)+'</div>\
          <div class="tp">$'+treatPrice(t).toFixed(2)+'</div>'+(avail?'<div class="add">+</div>':'<div class="soon">Coming soon</div>')+'</button>');
        if(avail){
          if(A.treats.indexOf(t.key)!==-1) card.classList.add('sel');
          card.onclick=function(){
            toggle(A.treats,t.key); card.classList.toggle('sel');
            var a=card.querySelector('.add'); if(a) a.textContent=card.classList.contains('sel')?'\u2713':'+';
            flashMascot('Good pick.');
          };
        } else { card.disabled=true; }
        grid.appendChild(card);
      });
      n.appendChild(grid);
    });

    if(hiddenCount > 0){ n.appendChild(el('<p class="q-sub" data-treats-hidden style="margin-top:12px">We\'ve hidden '+hiddenCount+' extra'+(hiddenCount>1?'s':'')+' whose listed ingredient is one of '+esc(A.allergies.join(', '))+'.</p>')); }
    if(isFrozen){ n.appendChild(el('<p class="q-sub" style="margin-top:12px">With frozen orders we add our air-dried treats only. Raw bones and complements ship separately.</p>')); }
    var nav = navRow('See my plan &#8594;', function(){ flashMascot('Building your plan...'); go(1); });
    var skip = el('<button class="btn ghost">Nothing extra</button>'); skip.onclick=function(){ A.treats=[]; go(1); };
    nav.row.appendChild(skip);
    n.appendChild(nav.row);
    mount(n);
  }

  /* ===================== VARIETY RESULT ===================== */
  /* 22 Oct 2026: ingredient filtering is not an allergy guarantee. Shown on the
     result screens whenever the owner selected (or typed) something to avoid. */
  var ALLERGY_NOTE = 'We filtered by listed ingredients only. This is not an allergy guarantee. Check the full ingredient list and talk to your vet about allergies.';
  // 26 Oct 2026: free-text "Other" entries can't be matched to ingredient lists; say so.
  function allergyNote(){
    return '<div class="help">'+ALLERGY_NOTE+(A._otherAllergy ? ' We couldn\'t check "'+esc(A._otherAllergy)+'" automatically, so please look for it in the ingredient list.' : '')+'</div>';
  }
  function allergyNoteNeeded(){
    var sel = (A.allergies||[]).filter(function(x){ return x !== '__other'; });
    return sel.length > 0 || !!A._otherAllergy;
  }

  function rResultVariety(){
    var pet = A.petName||('your '+A.species);
    var rec = QuizEngine.buildVarietyRecommendation(A);
    if(rec.noMatch || !rec.allocation.length){ return rNoMatch(); } // 26 Oct 2026: never an empty/incompatible cart
    var cap = rec.capacity, alloc = rec.allocation, f = rec.feeding;
    var unit = cap.unit;
    var routeLabel = A.format==='bulk' ? 'Bulk variety' : A.format==='frozen' ? 'Frozen variety' : 'Weekly variety';
    // human blend summary
    var blendNames = alloc.map(function(a){ return mixName(a.mixKey, A.format); });
    var totalKg = unit==='block' ? cap.totalUnits*10 : unit==='box' ? cap.totalUnits*5 : null;

    var n = el('<div></div>');
    n.appendChild(el('<div class="eyebrow">Your variety plan</div>'));
    var hero = el('<div class="result-hero">\
      <div class="result-top">\
        <div class="result-name">'+esc(pet)+'\'s variety blend</div>\
        <div class="result-pack">'+esc(routeLabel)+' &bull; '+alloc.length+' flavour'+(alloc.length>1?'s':'')+'</div>\
      </div>\
      <div class="result-body"></div>\
    </div>');
    var body = hero.querySelector('.result-body');

    // blend breakdown list
    body.appendChild(el('<div class="section-h">Your blend</div>'));
    var bl = el('<ul class="why-list"></ul>');
    alloc.forEach(function(a){
      var nm = mixName(a.mixKey, A.format);
      var amt = unit==='block' ? (a.units*10)+'kg bag' : unit==='box' ? (a.units===1?'1 box (5kg)':a.units+' boxes ('+(a.units*5)+'kg)') : (a.units===1?'1 weekly pack':a.units+' weekly packs');
      bl.appendChild(el('<li><span class="tick">&#10003;</span><span><strong>'+esc(nm)+'</strong> &middot; '+amt+'</span></li>'));
    });
    body.appendChild(bl);
    if(allergyNoteNeeded()) body.appendChild(el(allergyNote()));
    body.appendChild(el(sourcingNote()));
    (function(){
      var first = alloc[0]; if(!first) return;
      var box = el('<div class="result-photo"></div>'); hero.insertBefore(box, hero.firstChild);
      if(A.format === 'frozen'){ var fz = QuizEngine.DOG_FROZEN[first.mixKey]; if(fz) loadResultPhoto(box, fz.handle, fz.variantId); }
      else if(A.format === 'bulk'){ var db = A.species === 'cat' ? null : QuizEngine.DOG_BULK[first.mixKey]; if(db) loadResultPhoto(box, db.handle, null, db.opt); }
      else { loadResultPhoto(box, weeklyBandHandle(), null, mixName(first.mixKey, A.format)); }
    })();

    // CTA
    var cta = el('<div class="nav" style="margin-top:22px"><button class="btn" id="addCart">Add all to cart &#8594;</button></div>');
    body.appendChild(cta);
    if(A.deliveryPref) body.appendChild(el('<div class="help" style="text-align:center;margin-top:10px">Delivery: '+deliveryLabel(A.deliveryPref)+'.</div>'));
    n.appendChild(hero);

    // feeding / duration math
    var durDays = null;
    var dailyKg = f.gMid ? (f.gMid/1000) : null;
    if(totalKg && dailyKg){ durDays = Math.floor(totalKg / dailyKg); }
    var cells = '';
    cells += '<div class="feed-cell"><div class="feed-num">'+f.gLow+' to '+f.gHigh+'g</div><div class="feed-lbl">per day ('+f.meals+')</div></div>';
    cells += '<div class="feed-cell"><div class="feed-num">'+f.weeklyKg.toFixed(1)+'kg</div><div class="feed-lbl">per week</div></div>';
    if(totalKg){
      cells += '<div class="feed-cell"><div class="feed-num">'+totalKg+'kg</div><div class="feed-lbl">total in this plan</div></div>';
      if(durDays) cells += '<div class="feed-cell hl"><div class="feed-num">about '+durDays+' days</div><div class="feed-lbl">how long it lasts</div></div>';
    } else {
      cells += '<div class="feed-cell"><div class="feed-num">'+cap.weeks+' week'+(cap.weeks>1?'s':'')+'</div><div class="feed-lbl">'+alloc.length+' flavour'+(alloc.length>1?'s':'')+'</div></div>';
      cells += '<div class="feed-cell hl"><div class="feed-num">'+cap.totalUnits+' pack'+(cap.totalUnits>1?'s':'')+'</div><div class="feed-lbl">pre-portioned</div></div>';
    }
    n.appendChild(el('<div class="feed-summary"><div class="section-h">Feeding guide</div><div class="feed-grid">'+cells+'</div></div>'));
    if(unit==='box'){
      n.appendChild(el('<div class="help">Each 5kg box holds 10 x 500g portions. At about '+(f.gLow)+' to '+(f.gHigh)+'g a day, one 500g pack is roughly '+Math.max(1,Math.round(500/((f.gLow+f.gHigh)/2)))+' meal'+((Math.round(500/((f.gLow+f.gHigh)/2))>1)?'s':'')+' for '+esc(pet)+'.</div>'));
    }

    // chosen treats summary
    if(rec.treats && rec.treats.length){
      n.appendChild(el('<div class="section-h">Added treats</div>'));
      var tl = el('<div class="treat-grid"></div>');
      rec.treats.forEach(function(t){ tl.appendChild(el('<div class="treat sel"><div class="tn">'+t.name+'</div><div class="tp">$'+treatPrice(t).toFixed(2)+'</div></div>')); });
      n.appendChild(tl);
    }

    // email capture
    var em = el('<div class="email-box">\
      <h3>Get '+esc(pet)+'\'s variety plan + a welcome offer</h3>\
      <p>We\'ll email your full blend and a one-time welcome code instantly.</p>\
      <div class="email-row"><input class="field" type="email" placeholder="you@email.com" id="emailIn"><button class="btn" id="emailBtn" style="flex:0 0 auto">Send it</button></div>\
      <label class="consent"><input type="checkbox" id="consent" checked> Keep me posted with raw feeding tips and offers. You can unsubscribe anytime.</label>\
    </div>');
    n.appendChild(em);

    // share card
    var blendStr = blendNames.join(' + ');
    var share = el('<div class="share-card">\
      <div class="sc-pet">'+esc(pet)+'\'s variety blend &#128062;</div>\
      <div class="sc-pack">'+esc(blendStr)+' &bull; matched by K9 Raw</div>\
      <div class="sc-row"><button class="sc-btn" id="copyShare">Copy my result</button><button class="sc-btn" id="shareBtn">Share</button></div>\
    </div>');
    n.appendChild(share);

    n.appendChild(el('<div class="disclaimer">This recommendation is a feeding guide based on the details you provided, not veterinary advice. K9 Raw food supports healthy pets but does not treat, cure or prevent disease. If '+esc(pet)+' has a medical condition, please check with your vet before changing diet. We are happy to help you transition safely.</div>'));

    mount(n);

    // wire actions
    var built = varietyCartLines(rec);
    var cartUrl = buildVarietyCartUrl(rec);
    syncLiveForRec(rec).then(function(){
      built = varietyCartLines(rec);
      cartUrl = buildVarietyCartUrl(rec);
    });
    document.getElementById('addCart').onclick=function(){
      var btn=this; btn.disabled=true; var lbl=btn.innerHTML; btn.innerHTML='Adding\u2026';
      fireKlaviyoVariety(rec, cartUrl);
      addToStoreCart(built).then(function(ok){
        if(ok) return;                 // drawer opened with liner attached
        var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href=cartUrl;
      }).catch(function(){
        var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href=cartUrl;
      }).then(function(){ btn.disabled=false; btn.innerHTML=lbl; });
    };
    var emailBtn=document.getElementById('emailBtn'), emailIn=document.getElementById('emailIn'), consent=document.getElementById('consent');
    emailBtn.onclick=function(){
      var v=emailIn.value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ emailIn.focus(); emailIn.style.borderColor='var(--orange)'; return; }
      A.email=v; A.marketingConsent=consent.checked;
      fireKlaviyoVariety(rec, cartUrl);
      em.innerHTML='<h3>&#10003; Sent to '+esc(v)+'</h3><p>Check your inbox for '+esc(pet)+'\'s variety plan and your welcome offer. It can take a minute to arrive.</p>';
      flashMascot('Check your inbox!');
    };
    document.getElementById('copyShare').onclick=function(){
      copy(pet+'\'s K9 Raw variety blend: '+blendStr+'. Build your pet\'s plan at ardam.com.au'); flashMascot('Copied!');
    };
    document.getElementById('shareBtn').onclick=function(){
      var txt=pet+'\'s K9 Raw variety blend: '+blendStr;
      if(navigator.share){ navigator.share({title:'K9 Raw variety',text:txt,url:'https://ardam.com.au'}).catch(function(){}); }
      else { copy(txt+' https://ardam.com.au'); flashMascot('Copied!'); }
    };
  }

  // Resolve the weekly band handle for the dog at the current (activity-adjusted) weight.
  function weeklyBandHandle(){
    var adj = QuizEngine.applyActivity(A.weightKg, A.activity);
    if(A.species === 'cat'){
      var cb = (QuizEngine.CAT_WEEKLY||[]).filter(function(b){ return adj <= b.max; })[0];
      return cb ? cb.handle : null; // over 7.5kg cat -> no weekly band (bulk)
    }
    var band = QuizEngine.pickDogWeeklyBand(adj);
    return band ? band.handle : null;
  }
  function mixName(key, format){
    if(A.species === 'cat'){
      var cm = (QuizEngine.CAT_MIXES||[]).filter(function(x){return x.key===key;})[0];
      return cm ? cm.name : key;
    }
    if(format==='frozen' && QuizEngine.DOG_FROZEN[key]) return QuizEngine.DOG_FROZEN[key].name.replace(/^Frozen /,'');
    var m = QuizEngine.MIXES.filter(function(x){return x.key===key;})[0];
    return m ? m.name : key;
  }

  /* ===================== RESULT ===================== */
  function rResult(){
    if(A.planType === 'variety'){ return rResultVariety(); }
    var rec = QuizEngine.buildRecommendation(A);
    if(rec.noMatch){ return rNoMatch(); } // 26 Oct 2026: no incompatible recommendation can be added
    var pet = A.petName||('your '+A.species);
    var n = el('<div></div>');
    n.appendChild(el('<div class="eyebrow">Your match</div>'));
    var hero = el('<div class="result-hero">\
      <div class="result-top">\
        <div class="result-name">'+esc(pet)+'\'s plan: '+esc(rec.mix.name)+'</div>\
        <div class="result-pack">'+esc(rec.product.name)+'</div>\
      </div>\
      <div class="result-body"></div>\
    </div>');
    var body = hero.querySelector('.result-body');
    body.appendChild(el('<div class="section-h">Why this plan</div>'));
    var why = el('<ul class="why-list"></ul>');
    rec.reasons.forEach(function(r){ why.appendChild(el('<li><span class="tick">&#10003;</span><span>'+esc(r)+'</span></li>')); });
    body.appendChild(why);
    if(allergyNoteNeeded()) body.appendChild(el(allergyNote()));
    body.appendChild(el(sourcingNote()));
    var photoBox = el('<div class="result-photo"></div>'); hero.insertBefore(photoBox, hero.firstChild);
    loadResultPhoto(photoBox, rec.product && rec.product.handle, rec.product && rec.product.variantId, rec.mix && (rec.product && rec.product.kind === 'dog_bulk' ? (QuizEngine.DOG_BULK[rec.mix.key]||{}).opt : rec.mix.name));

    // CTA add to cart
    var cta = el('<div class="nav" style="margin-top:22px"><button class="btn" id="addCart">Add to cart &#8594;</button></div>');
    body.appendChild(cta);
    if(A.deliveryPref) body.appendChild(el('<div class="help" style="text-align:center;margin-top:10px">Delivery: '+deliveryLabel(A.deliveryPref)+'.</div>'));
    n.appendChild(hero);

    // Cat flavour swap: cats are always under the 20kg variety threshold, so the
    // plan is always a single Essentials mix. Let the owner change which flavour
    // it is (allergy-filtered) instead of being locked to the matched default.
    if(A.species === 'cat'){
      var catPool = QuizEngine.CAT_MIXES.filter(function(m){
        return QuizEngine.mixAllowedByAllergies(m, A.allergies || []);
      });
      if(catPool.length > 1){
        var swap = el('<div class="flavour-swap"><div class="section-h">Prefer a different flavour?</div>\
          <p class="q-sub" style="margin:2px 0 10px">Pick the one '+esc(pet)+' will love. We\'ll update the plan.</p></div>');
        var chips = el('<div class="chips"></div>');
        catPool.forEach(function(m){
          var proto = m.proteins[0];
          var isSel = (rec.product && rec.product.protein === proto);
          var c = el('<button class="chip'+(isSel?' sel':'')+'">'+esc(m.name)+'</button>');
          c.onclick=function(){ A.catMixOverride = proto; flashMascot('Updated.'); render(); };
          chips.appendChild(c);
        });
        swap.appendChild(chips);
        n.appendChild(swap);
      }
    }

    // Bulk feeding breakdown
    if(rec.format === 'bulk' && rec.bulk && rec.feeding){
      var f = rec.feeding, bk = rec.bulk;
      var fb = el('<div class="feed-summary">\
        <div class="section-h">Feeding guide</div>\
        <div class="feed-grid">\
          <div class="feed-cell"><div class="feed-num">'+f.gLow+' to '+f.gHigh+'g</div><div class="feed-lbl">per day ('+f.meals+')</div></div>\
          <div class="feed-cell"><div class="feed-num">'+f.weeklyKg.toFixed(1)+'kg</div><div class="feed-lbl">per week</div></div>\
          <div class="feed-cell"><div class="feed-num">'+bk.weeks+' week'+(bk.weeks>1?'s':'')+'</div><div class="feed-lbl">about '+bk.totalNeededKg.toFixed(1)+'kg needed</div></div>\
          <div class="feed-cell hl"><div class="feed-num">'+bk.bagKg+'kg bag</div><div class="feed-lbl">matched for you</div></div>\
        </div></div>');
      n.appendChild(fb);
    }

    // chosen treats summary
    if(rec.treats && rec.treats.length){
      var ts = el('<div class="section-h">Added treats</div>'); n.appendChild(ts);
      var tl = el('<div class="treat-grid"></div>');
      rec.treats.forEach(function(t){ tl.appendChild(el('<div class="treat sel"><div class="tn">'+t.name+'</div><div class="tp">$'+treatPrice(t).toFixed(2)+'</div></div>')); });
      n.appendChild(tl);
    }

    // email capture
    var em = el('<div class="email-box">\
      <h3>Get '+esc(pet)+'\'s plan + a welcome offer</h3>\
      <p>We\'ll email your results and a one-time welcome code instantly.</p>\
      <div class="email-row"><input class="field" type="email" placeholder="you@email.com" id="emailIn"><button class="btn" id="emailBtn" style="flex:0 0 auto">Send it</button></div>\
      <label class="consent"><input type="checkbox" id="consent" checked> Keep me posted with raw feeding tips and offers. You can unsubscribe anytime.</label>\
    </div>');
    n.appendChild(em);

    // share card
    var share = el('<div class="share-card">\
      <div class="sc-pet">'+esc(pet)+' is a '+esc(rec.mix.name)+' kind of '+(A.species)+' &#128062;</div>\
      <div class="sc-pack">'+esc(rec.product.name)+' &bull; matched by K9 Raw</div>\
      <div class="sc-row"><button class="sc-btn" id="copyShare">Copy my result</button><button class="sc-btn" id="shareBtn">Share</button></div>\
    </div>');
    n.appendChild(share);

    n.appendChild(el('<div class="disclaimer">This recommendation is a feeding guide based on the details you provided, not veterinary advice. K9 Raw food supports healthy pets but does not treat, cure or prevent disease. If '+esc(pet)+' has a medical condition, please check with your vet before changing diet. We are happy to help you transition safely.</div>'));

    mount(n);

    // wire actions
    var built = specificCartLines(rec);
    var cartUrl = buildCartUrl(rec);
    // Re-resolve every variant against the live catalogue, then rebuild the
    // cart lines + permalink so a catalogue change can never strand the quiz.
    syncLiveForRec(rec).then(function(){
      built = specificCartLines(rec);
      cartUrl = buildCartUrl(rec);
    });
    document.getElementById('addCart').onclick=function(){
      var btn=this; btn.disabled=true; var lbl=btn.innerHTML; btn.innerHTML='Adding\u2026';
      fireKlaviyo(rec, cartUrl);
      addToStoreCart(built).then(function(ok){
        if(ok) return;                 // drawer opened with liner attached
        var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href=cartUrl;
      }).catch(function(){
        var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href=cartUrl;
      }).then(function(){ btn.disabled=false; btn.innerHTML=lbl; });
    };
    var emailBtn=document.getElementById('emailBtn'), emailIn=document.getElementById('emailIn'), consent=document.getElementById('consent');
    emailBtn.onclick=function(){
      var v=emailIn.value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ emailIn.focus(); emailIn.style.borderColor='var(--orange)'; return; }
      A.email=v; A.marketingConsent=consent.checked;
      fireKlaviyo(rec, cartUrl);
      em.innerHTML='<h3>&#10003; Sent to '+esc(v)+'</h3><p>Check your inbox for '+esc(pet)+'\'s plan and your welcome offer. It can take a minute to arrive.</p>';
      flashMascot('Check your inbox!');
    };
    document.getElementById('copyShare').onclick=function(){
      var txt=pet+'\'s K9 Raw match: '+rec.mix.name+' ('+rec.product.name+'). Build your pet\'s plan at ardam.com.au';
      copy(txt); flashMascot('Copied!');
    };
    document.getElementById('shareBtn').onclick=function(){
      var txt=pet+'\'s K9 Raw match: '+rec.mix.name;
      if(navigator.share){ navigator.share({title:'K9 Raw match',text:txt,url:'https://ardam.com.au'}).catch(function(){}); }
      else { copy(txt+' https://ardam.com.au'); flashMascot('Copied!'); }
    };
  }

  /* ---------- cart + klaviyo ---------- */

  // Build the cart attribute string (cart notes) shared by permalink + AJAX paths.
  function cartAttrParams(extra){
    var p = { quiz_pet: A.petName||'', delivery_pref: A.deliveryPref||'' };
    Object.keys(extra||{}).forEach(function(k){ p[k]=extra[k]; });
    return p;
  }
  function attrQuery(params){
    return '?' + Object.keys(params).map(function(k){
      return 'attributes['+k+']='+encodeURIComponent(params[k]);
    }).join('&');
  }

  /* =================================================================
     LIVE VARIANT RESOLVER (permanent fix, Aug 2026)
     ------------------------------------------------------------------
     Root cause of the "Link no longer exists" cart errors: the variant
     map was baked at build time. When the catalogue was consolidated on
     20 Aug 2026 the per-mix frozen and bulk products were set to DRAFT,
     so every baked frozen/bulk variant id pointed at an unpublished
     product and Shopify rejected the /cart/<id>:1 permalink.

     This resolver makes the quiz self-healing: before any cart link or
     AJAX add is built, it fetches /products/<handle>.js for the handles
     the recommendation needs and rewrites window.ARDAM_VARIANT_MAP from
     LIVE data, keyed 'handle', 'handle::Opt1' and 'handle::Opt1::Opt2'.
     Only variants Shopify reports as available are kept. If a handle no
     longer serves public JSON (draft / deleted) its keys are dropped, so
     we never emit a link to something a customer cannot buy.
     ================================================================= */
  var LIVE_HANDLES = {};   // handle -> Promise
  var LIVE_OK = {};        // variantId(string) -> true, verified purchasable

  function syncLiveHandle(handle){
    if(!handle) return Promise.resolve(false);
    if(LIVE_HANDLES[handle]) return LIVE_HANDLES[handle];
    var pr = fetch('/products/'+handle+'.js', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        var map = window.ARDAM_VARIANT_MAP = (window.ARDAM_VARIANT_MAP || {});
        if(!p || !p.variants || !p.variants.length){
          // handle is gone or unpublished -> drop its stale keys
          Object.keys(map).forEach(function(k){
            if(k === handle || k.indexOf(handle+'::') === 0) delete map[k];
          });
          return false;
        }
        // clear then rebuild this handle's keys from live data
        Object.keys(map).forEach(function(k){
          if(k === handle || k.indexOf(handle+'::') === 0) delete map[k];
        });
        var first = null;
        p.variants.forEach(function(v){
          if(v.available === false) return;
          var vid = String(v.id);
          LIVE_OK[vid] = true;
          if(!first){ first = vid; map[handle] = vid; }
          var o = v.options || [];
          if(o.length === 1){
            if(!map[handle+'::'+o[0]]) map[handle+'::'+o[0]] = vid;
          } else if(o.length >= 2){
            var k2 = handle+'::'+o[0]+'::'+o[1];
            if(!map[k2]) map[k2] = vid;
            if(!map[handle+'::'+o[0]]) map[handle+'::'+o[0]] = vid;
          }
        });
        return true;
      })
      .catch(function(){ return false; });
    LIVE_HANDLES[handle] = pr;
    return pr;
  }

  /* handles the current recommendation could need */
  function recHandles(rec){
    var hs = [];
    if(rec && rec.product && rec.product.handle) hs.push(rec.product.handle);
    // variety allocations span every mix in the chosen format
    try{
      if(A.format === 'bulk'){
        if(A.species === 'cat'){ Object.keys(QuizEngine.CAT_BULK).forEach(function(k){ hs.push(QuizEngine.CAT_BULK[k].handle); }); }
        else { Object.keys(QuizEngine.DOG_BULK).forEach(function(k){ hs.push(QuizEngine.DOG_BULK[k].handle); }); }
      } else if(A.format === 'frozen'){
        Object.keys(QuizEngine.DOG_FROZEN).forEach(function(k){ hs.push(QuizEngine.DOG_FROZEN[k].handle); });
      } else {
        var wh = weeklyBandHandle(); if(wh) hs.push(wh);
      }
    }catch(e){}
    (rec && rec.treats || []).forEach(function(t){ if(t.handle) hs.push(t.handle); });
    var seen = {}, out = [];
    hs.forEach(function(h){ if(h && !seen[h]){ seen[h] = 1; out.push(h); } });
    return out;
  }
  function syncLiveForRec(rec){
    return Promise.all(recHandles(rec).map(syncLiveHandle));
  }
  /* Drop any line we could not verify as purchasable, so a permalink never
     points at a draft/deleted variant. Only filters once we actually have
     live data (LIVE_OK populated), never on the offline preview. */
  function verifiedLines(lines){
    if(!Object.keys(LIVE_OK).length) return lines || [];
    return (lines || []).filter(function(l){ return LIVE_OK[String(l.id)]; });
  }

  /* specificCartLines: resolve the chosen plan + treats to AJAX line items.
     Returns {lines:[{id,qty}], attrs:{...}, fallbackHandle} or null if the main
     product variant can't be resolved (e.g. on the local preview). */
  function specificCartLines(rec){
    // Map is keyed three ways:
    //   'handle::MixName'    (weekly / puppy / cat weekly -> the chosen Mix variant)
    //   'handle::WeightLabel'(bulk -> a size; engine defaults bulk to 10kg)
    //   'handle'             (plain default variant for the product)
    var map = window.ARDAM_VARIANT_MAP || {};
    var h = rec.product.handle;
    var vid;
    if(rec.product.kind === 'dog_frozen'){
      // frozen resolves to an explicit variant on the consolidated
      // `frozen-raw-dog-food` product (the per-mix frozen products were
      // retired in the 2026-08 catalogue consolidation).
      var fz = QuizEngine.DOG_FROZEN[rec.product.mixKey];
      vid = rec.product.variantId
            || (fz && (map[h+'::'+fz.opt] || fz.variantId))
            || map[h];
    } else if(rec.product.kind === 'dog_bulk'){
      // one consolidated `bulk-raw-dog-food` product: Protein x Weight.
      var dbk = QuizEngine.DOG_BULK[rec.product.mixKey];
      var bkg = rec.product.bagKg || 10;
      vid = (dbk && (map[h+'::'+dbk.opt+'::'+bkg+'kg'] || map[h+'::'+dbk.opt]))
            || map[h+'::'+bkg+'kg'] || map[h];
    } else if(rec.product.kind === 'cat_bulk'){
      // one consolidated `bulk-cat-food` product: Protein x Weight.
      var cbk = QuizEngine.CAT_BULK[rec.product.protein] || QuizEngine.CAT_BULK.chicken;
      var ckg = rec.product.bagKg || 10;
      vid = map[h+'::'+cbk.opt+'::'+ckg+'kg'] || map[h+'::'+cbk.opt] || map[h];
    } else if(rec.product.kind === 'cat_weekly'){
      // Cat weekly carries only the 3 Essentials proteins; resolve by the
      // engine-chosen cat protein, not the dog mix name.
      var copt = {chicken:'Essentials Chicken', duck:'Essentials Duck', kangaroo:'Essentials Kangaroo'}[rec.product.protein] || 'Essentials Chicken';
      vid = map[h+'::'+copt] || map[h];
    } else {
      vid = (rec.mix && map[h+'::'+rec.mix.name]) || map[h];
    }
    if(!vid) return { lines:[], attrs:{}, fallbackHandle:h };
    var lines = [{ id: parseInt(vid,10), quantity: 1 }];
    (rec.treats||[]).forEach(function(t){
      if(!treatAvailable(t)) return;                // skip gated / out-of-stock complements
      var tv = treatVariantId(t);
      if(tv) lines.push({ id: parseInt(tv,10), quantity: 1 });
    });
    return {
      lines: lines,
      attrs: cartAttrParams({ quiz_mix: (rec.mix&&rec.mix.name)||'', quiz_plan: 'specific' }),
      fallbackHandle: h
    };
  }

  function buildCartUrl(rec){
    // Permalink fallback only. Primary path is addToStoreCart (AJAX), which lets
    // Brett's mini-cart attach the liner + ice pack. This permalink is used when
    // the AJAX cart API isn't available (e.g. the local preview).
    var b = specificCartLines(rec);
    b.lines = verifiedLines(b.lines);
    if(!b.lines.length) return '/products/'+b.fallbackHandle;
    var parts = b.lines.map(function(l){ return l.id+':'+l.quantity; });
    return '/cart/'+parts.join(',')+attrQuery(b.attrs);
  }

  /* ===================================================================
     buildEmailAddUrl: the link we hand to Klaviyo for the email CTA.
     It points back at THIS page (/pages/quiz) with an `add=` payload,
     so when the customer clicks it from the email we run the SAME
     on-site AJAX add path the end-of-quiz button uses (handleEmailAdd
     below). That lets Brett's mini-cart attach the liner + ice packs,
     exactly like finishing the quiz on site. Falls back to the raw
     /cart/ permalink if JS doesn't run for some reason.
     `add`  = comma-joined ID:QTY pairs
     `a_*`  = cart attribute params (quiz_pet, quiz_mix, etc.)
     =================================================================== */
  function buildEmailAddUrl(built, fallbackPermalink){
    var b = built || {};
    var lines = b.lines || [];
    if(!lines.length) return location.origin + (fallbackPermalink || '/cart');
    var add = lines.map(function(l){ return l.id+':'+l.quantity; }).join(',');
    var qs = ['add='+encodeURIComponent(add)];
    var attrs = b.attrs || {};
    Object.keys(attrs).forEach(function(k){
      qs.push('a_'+encodeURIComponent(k)+'='+encodeURIComponent(attrs[k]));
    });
    // permalink kept so the landing handler can hard-redirect if AJAX is missing
    if(fallbackPermalink) qs.push('cp='+encodeURIComponent(fallbackPermalink));
    return location.origin + '/pages/quiz?' + qs.join('&');
  }

  /* handleEmailAdd: run once on page load. If the URL carries an `add=`
     payload (customer arrived from the email CTA), rebuild the line items
     + cart attributes and run the on-site add path so Brett's mini-cart
     attaches liner/ice. Returns true if it handled an email add (so the
     quiz UI can skip rendering the intro). */
  function handleEmailAdd(){
    var qp;
    try { qp = new URLSearchParams(location.search); } catch(e){ return false; }
    var add = qp.get('add');
    if(!add) return false;
    var lines = [];
    add.split(',').forEach(function(pair){
      var m = /^(\d+):(\d+)$/.exec(pair.trim());
      if(m) lines.push({ id: parseInt(m[1],10), quantity: parseInt(m[2],10) });
    });
    if(!lines.length) return false;
    var attrs = {};
    qp.forEach(function(val, key){ if(key.indexOf('a_')===0) attrs[key.slice(2)] = val; });
    var cp = qp.get('cp');
    var permalink = cp || ('/cart/'+lines.map(function(l){return l.id+':'+l.quantity;}).join(',')
                            + (Object.keys(attrs).length ? attrQuery(attrs) : ''));
    var built = { lines: lines, attrs: attrs, fallbackHandle: '' };
    // Show a lightweight "adding" state in #stage instead of the quiz intro.
    if(stage){ stage.innerHTML = '<div class="result" style="text-align:center;padding:48px 16px;">'
      + '<h2>Adding your plan to cart\u2026</h2>'
      + '<p>One moment while we get '+'your pet'+'\u2019s plan ready.</p></div>'; }
    addToStoreCart(built).then(function(ok){
      if(ok) return;                 // AJAX add ran, drawer opened, Brett's app attached liner/ice
      var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href = permalink;
    }).catch(function(){
      var t; try{t=window.top;}catch(e){t=window;} (t||window).location.href = permalink;
    });
    return true;
  }

  /* varietyCartLines: resolve the multi-mix allocation + treats to AJAX line items
     via the engine. Returns {lines:[{id,qty}], attrs:{...}, fallbackHandle}. */
  function varietyCartLines(rec){
    var ctx = { species: A.species, weeklyHandle: (A.format==='weekly') ? weeklyBandHandle() : null };
    var built = QuizEngine.buildVarietyCart(A.format, rec.allocation, ctx);
    var lines = [];
    built.lines.forEach(function(l){ if(l.variantId) lines.push({ id: parseInt(l.variantId,10), quantity: (l.qty||1) }); });
    var map = window.ARDAM_VARIANT_MAP || {};
    (rec.treats||[]).forEach(function(t){
      if(!treatAvailable(t)) return;
      var tv = treatVariantId(t);
      if(tv) lines.push({ id: parseInt(tv,10), quantity: 1 });
    });
    var firstKey = rec.allocation[0] && rec.allocation[0].mixKey;
    var catBulkHandle = null;
    if(A.species==='cat' && A.format==='bulk'){
      var cp = {ess_chicken:'chicken',ess_duck:'duck',ess_kangaroo:'kangaroo'}[firstKey] || 'chicken';
      catBulkHandle = QuizEngine.CAT_BULK[cp] && QuizEngine.CAT_BULK[cp].handle;
    }
    var fallbackHandle = catBulkHandle
          ? catBulkHandle
          : (A.format==='bulk' && QuizEngine.DOG_BULK[firstKey]) ? QuizEngine.DOG_BULK[firstKey].handle
          : (A.format==='frozen' && QuizEngine.DOG_FROZEN[firstKey]) ? QuizEngine.DOG_FROZEN[firstKey].handle
          : ctx.weeklyHandle;
    var mixesCsv = rec.allocation.map(function(a){ return mixName(a.mixKey, A.format); }).join(', ');
    return {
      lines: lines,
      attrs: cartAttrParams({ quiz_plan: 'variety', quiz_mixes: mixesCsv }),
      fallbackHandle: fallbackHandle
    };
  }

  function buildVarietyCartUrl(rec){
    // Permalink fallback only (see buildCartUrl note).
    var b = varietyCartLines(rec);
    b.lines = verifiedLines(b.lines);
    if(!b.lines.length) return b.fallbackHandle ? '/products/'+b.fallbackHandle : '/cart';
    var parts = b.lines.map(function(l){ return l.id+':'+l.quantity; });
    return '/cart/'+parts.join(',')+attrQuery(b.attrs);
  }

  /* =================================================================
     addToStoreCart: PRIMARY add-to-cart path.
     Adds ONLY the food, exactly as a normal Shopify add-to-cart would.
     Brett's mini-cart / checkout logic owns ALL liner, ice-pack and box
     math (for fresh food + complements/bones); frozen gets none. We just
     add the line items, set the quiz cart attributes, and open the cart
     so the store's existing logic runs unchanged.
     Falls back to the /cart/ permalink redirect when the AJAX API isn't
     present (e.g. the local QA preview).
     ================================================================= */
  function ajaxAdd(items){
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      if(!r.ok) return r.json().then(function(j){ throw new Error(j && j.description || ('cart/add '+r.status)); });
      return r.json();
    });
  }
  function updateCartAttributes(attrs){
    if(!attrs || !Object.keys(attrs).length) return Promise.resolve();
    return fetch('/cart/update.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r){ return r.json(); }).catch(function(){});
  }
  function openCartDrawer(){
    if(typeof window.refreshCart === 'function'){ try{ window.refreshCart(); return; }catch(e){} }
    var handle = document.querySelector('[data-js-sidebar-handle][aria-controls="site-cart-sidebar"]');
    if(handle){ try{ handle.click(); return; }catch(e){} }
    var d = document.getElementById('site-cart-sidebar');
    if(d && typeof d.show === 'function'){ try{ d.show(); }catch(e){} }
  }
  // Returns true if it handled the add via AJAX; false if caller should use the permalink.
  //
  // IMPORTANT (owner decision, 4 Jun 2026): the planner adds ONLY the food, exactly
  // as a normal Shopify add-to-cart would. It must NOT add liners or ice packs.
  // Brett's mini-cart / checkout logic owns all liner, ice-pack and box-count math
  // (for fresh food + complements/bones). Frozen orders get no liner/ice pack at all.
  // We just add the line items, set the quiz attributes, and open the cart so the
  // store's existing logic runs the same way it does for any other add-to-cart.
  function addToStoreCart(built){
    var lines = (built && built.lines) || [];
    if(!lines.length) return Promise.resolve(false);
    // Only use the AJAX path on the real storefront (Shopify AJAX cart present).
    // The local QA preview has no /cart/add.js, so we fall back to the permalink.
    var hasAjaxCart = (typeof fetch === 'function') && !!(window.CART_ADDON_CONFIG);
    if(!hasAjaxCart) return Promise.resolve(false);
    return ajaxAdd(lines).then(function(){
      return updateCartAttributes(built.attrs);
    }).then(function(){
      openCartDrawer();
      return true;
    }).catch(function(err){
      // A line was rejected (usually a variant that has since been unpublished).
      // Re-resolve the handles from live Shopify JSON, drop anything still
      // unpurchasable, and retry once before falling back.
      try{ console.warn('cart/add rejected, re-resolving live variants:', err); }catch(e){}
      if(built._retried) return false;
      built._retried = true;
      return Promise.all(Object.keys(LIVE_HANDLES).length
              ? Object.keys(LIVE_HANDLES).map(function(h){ delete LIVE_HANDLES[h]; return syncLiveHandle(h); })
              : [Promise.resolve()])
        .then(function(){
          var retryLines = verifiedLines(built.lines);
          if(!retryLines.length) return false;
          return ajaxAdd(retryLines)
            .then(function(){ return updateCartAttributes(built.attrs); })
            .then(function(){ openCartDrawer(); return true; })
            .catch(function(){ return false; });
        })
        .catch(function(){ return false; });
    });
  }

  function fireKlaviyo(rec, cartUrl){
    if(fireKlaviyo._sent && !A.email) return;
    var f = rec.feeding || {};
    var b = rec.bulk || null;
    // Email CTA must run the on-site add path so Brett's mini-cart attaches
    // liner/ice. Hand Klaviyo a /pages/quiz?add=... link (not the raw /cart/
    // permalink, which skips the add-on logic). cartUrl is kept as fallback.
    var emailAddUrl = buildEmailAddUrl(specificCartLines(rec), cartUrl);
    var props = {
      species:A.species, pet_name:A.petName, breed:A.breed||null, life_stage:A.lifeStage,
      age_months:A.ageMonths||null, weight_kg:A.weightKg, activity:A.activity,
      health_goals:A.health, allergies:A.allergies.concat(A._otherAllergy?[A._otherAllergy]:[]),
      current_brand:A.currentBrand||null, priority:A.priority, format:rec.format,
      delivery_pref:A.deliveryPref, recommended_mix:rec.mix.name, recommended_product:rec.product.name,
      recommended_handle:rec.product.handle, treats:(rec.treats||[]).map(function(t){return t.name;}),
      cart_permalink:emailAddUrl, marketing_consent:A.marketingConsent,
      // --- tailored feeding plan (so the email renders exactly the on-screen plan) ---
      delivery_label:deliveryLabel(A.deliveryPref),
      feed_stage:f.stageName||null, feed_meals:f.meals||null,
      feed_g_low:(f.gLow!=null?f.gLow:null), feed_g_high:(f.gHigh!=null?f.gHigh:null),
      feed_g_per_day:(f.gLow!=null?(f.gLow+' to '+f.gHigh+'g'):null),
      feed_kg_per_week:(f.weeklyKg!=null?Number(f.weeklyKg.toFixed(2)):null),
      bulk_weeks:(b?b.weeks:null), bulk_weeks_label:(b?(b.weeks>1?'weeks':'week'):null),
      bulk_total_kg:(b?Number(b.totalNeededKg.toFixed(1)):null),
      bulk_bag_kg:(b?b.bagKg:null),
      // single-line summaries for easy email merge tags
      plan_headline:(A.petName||'Your pet')+"'s plan: "+rec.product.name,
      feeding_summary:(f.gLow!=null
        ? (A.petName||'Your pet')+' eats about '+f.gLow+' to '+f.gHigh+'g a day ('+f.meals+'), roughly '+f.weeklyKg.toFixed(1)+'kg a week.'
        : null),
      bulk_summary:(b
        ? 'For '+b.weeks+' week'+(b.weeks>1?'s':'')+' that is about '+b.totalNeededKg.toFixed(1)+'kg, matched to the '+b.bagKg+'kg bag.'
        : null)
    };
    // Klaviyo onsite tracking
    try{
      window._learnq = window._learnq || [];
      if(A.email) window._learnq.push(['identify', {'$email':A.email, 'PetSpecies':A.species, 'PetName':A.petName}]);
      window._learnq.push(['track', 'Completed Quiz', props]);
      fireKlaviyo._sent = true;
    }catch(e){ console.warn('klaviyo not ready', e); }
    // also expose for server-side/back-end capture
    if(window.ARDAM_ON_QUIZ_COMPLETE) try{ window.ARDAM_ON_QUIZ_COMPLETE(props); }catch(e){}
    // console.log('[QUIZ] Completed Quiz event', props);
  }

  /* Variety analogue of fireKlaviyo. Same base fields the email already merges
     (so a variety result still renders a plan), plus plan_type='variety', a
     variety_mixes array of {name,units,kg}, and a one-line variety_summary. */
  function fireKlaviyoVariety(rec, cartUrl){
    if(fireKlaviyo._sent && !A.email) return;
    var f = rec.feeding || {};
    var cap = rec.capacity || {};
    // Email CTA -> on-site add path (see fireKlaviyo note). cartUrl is fallback.
    var emailAddUrl = buildEmailAddUrl(varietyCartLines(rec), cartUrl);
    var unit = cap.unit;
    var mixes = (rec.allocation||[]).map(function(a){
      var nm = mixName(a.mixKey, A.format);
      var kg = unit==='block' ? a.units*10 : unit==='box' ? a.units*5 : null;
      return {name:nm, units:a.units, kg:kg};
    });
    var totalKg = unit==='block' ? cap.totalUnits*10 : unit==='box' ? cap.totalUnits*5 : null;
    var unitNoun = unit==='block'?'10kg bag':unit==='box'?'5kg box':'weekly pack';
    var summaryParts = mixes.map(function(m){
      return m.name+' ('+(unit==='block'? (m.kg+'kg') : unit==='box' ? (m.units+' x 5kg box'+(m.units>1?'es':'')) : (m.units+' pack'+(m.units>1?'s':'')))+')';
    });
    var props = {
      species:A.species, pet_name:A.petName, breed:A.breed||null, life_stage:A.lifeStage,
      age_months:A.ageMonths||null, weight_kg:A.weightKg, activity:A.activity,
      health_goals:A.health, allergies:A.allergies.concat(A._otherAllergy?[A._otherAllergy]:[]),
      current_brand:A.currentBrand||null, priority:A.priority, format:rec.format,
      delivery_pref:A.deliveryPref, delivery_label:deliveryLabel(A.deliveryPref),
      treats:(rec.treats||[]).map(function(t){return t.name;}),
      cart_permalink:emailAddUrl, marketing_consent:A.marketingConsent,
      // feeding (same keys the email uses)
      feed_stage:f.stageName||null, feed_meals:f.meals||null,
      feed_g_low:(f.gLow!=null?f.gLow:null), feed_g_high:(f.gHigh!=null?f.gHigh:null),
      feed_g_per_day:(f.gLow!=null?(f.gLow+' to '+f.gHigh+'g'):null),
      feed_kg_per_week:(f.weeklyKg!=null?Number(f.weeklyKg.toFixed(2)):null),
      feeding_summary:(f.gLow!=null
        ? (A.petName||'Your pet')+' eats about '+f.gLow+' to '+f.gHigh+'g a day ('+f.meals+'), roughly '+f.weeklyKg.toFixed(1)+'kg a week.'
        : null),
      // --- variety extension ---
      plan_type:'variety',
      recommended_mix:mixes.map(function(m){return m.name;}).join(' + '),
      recommended_product:(rec.format==='bulk'?'Bulk variety':rec.format==='frozen'?'Frozen variety':'Weekly variety'),
      variety_route:rec.format,
      variety_mix_count:mixes.length,
      variety_unit:unitNoun,
      variety_total_units:cap.totalUnits||null,
      variety_total_kg:(totalKg||null),
      variety_mixes:mixes,
      variety_summary:(A.petName||'Your pet')+"'s variety blend: "+summaryParts.join(', ')+'.',
      plan_headline:(A.petName||'Your pet')+"'s variety blend"
    };
    try{
      window._learnq = window._learnq || [];
      if(A.email) window._learnq.push(['identify', {'$email':A.email, 'PetSpecies':A.species, 'PetName':A.petName}]);
      window._learnq.push(['track', 'Completed Quiz', props]);
      fireKlaviyo._sent = true;
    }catch(e){ console.warn('klaviyo not ready', e); }
    if(window.ARDAM_ON_QUIZ_COMPLETE) try{ window.ARDAM_ON_QUIZ_COMPLETE(props); }catch(e){}
    // console.log('[QUIZ] Completed Quiz event (variety)', props);
  }

  /* ---------- utils ---------- */
  function toggle(arr,v){ var i=arr.indexOf(v); if(i===-1)arr.push(v); else arr.splice(i,1); }
  function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
  function stepLabel(){ var list=steps(); var realIdx=idx-1; var totalQ=list.length-3; return 'Step '+realIdx+' of '+totalQ; }
  function deliveryLabel(d){ return {weekly_fresh:'Fresh, weekly',bulk:'Bulk',frozen:'Frozen, next-day'}[d]||d; }
  function copy(t){ try{ navigator.clipboard.writeText(t); }catch(e){ var ta=document.createElement('textarea'); ta.value=t; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); } }

  function goBack(){
    var list=steps();
    if(idx<=0) return;
    var prev = idx-1;
    // never land back on the intro splash; the first reachable step is species (idx 1)
    if(list[prev]==='intro') prev = 1;
    idx = prev;
    flashMascot('Sure.');
    render();
  }
  if(backBtn){ backBtn.onclick = goBack; }

  // start
  // If the customer arrived from the email CTA (?add=...), run the on-site
  // add path (so Brett's mini-cart attaches liner/ice) instead of the intro.
  if(!handleEmailAdd()) render();

  // Pull live Shopify prices in the background; refresh the view if the user is
  // already on a step that shows prices once they arrive.
  fetchTreatPrices().then(function(){
    var cur = steps()[idx];
    if(cur === 'treats' || cur === 'result') render();
  });
})();
